import { quickSightService } from './index'

export const fetchQuickSiteListByModule = (tenantId: string, module: string) => quickSightService.get(`api/v1/dashboard/list_by_group?tenant_id=${tenantId}&module=${module}`);

export const postQuickSightReport = (body: any) => quickSightService.post('/api/v1/generate_report_url', body);
